import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Icon from 'components/atoms/Icon';

const useStyles = makeStyles((theme) => ({
  orderIco: {
    cursor: 'pointer',
    '& svg': { opacity: 0.4 },
    '&:hover svg': { opacity: 1 },
  },
  outsideSortIcon: {
    marginLeft: 2,
    transition: 'all ease 0.4s',
    '&.active': { '& svg': { opacity: 1 } },
    '& svg': { color: theme.palette.table.text, opacity: 0.4 },
    '&.asc': { transform: 'rotate(180deg)' },
    '&.desc': { transform: 'rotate(0deg)' },
  },
}));

const SortLabelWrap = (props) => {
  const classes = useStyles();
  const { label, params, clickEvent, orderKey, ...rest } = props;
  const { sort, order } = params;
  return (
    <TableSortLabel
      className={classes.orderIco}
      active={order === orderKey}
      onClick={clickEvent}
      direction={sort}
      IconComponent={() => {
        return (
          <div
            className={clsx(classes.outsideSortIcon, {
              active: order === orderKey,
              asc: order === orderKey && sort === 'asc',
              desc: sort === 'desc',
            })}
          >
            <Icon icon={'faCaretDown'} color={'default'} />
          </div>
        );
      }}
      {...rest}
    >
      {label}
    </TableSortLabel>
  );
};

export default SortLabelWrap;
